import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vehiclesComponent from './vehicles.component';
import dataTable from 'angular-material-data-table';

let vehiclesModule = angular.module('vehicles', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('vehicles', {
        url: '/vehicles',
        component: 'vehicles',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('vehicles', vehiclesComponent)
.name;

export default vehiclesModule;
